module.exports = __webpack_public_path__ + "static/media/poweredbydq.c7b2f4c5.png";